__webpack_require__.p = "https://static.millesima.com/s3/prod-2/_next/";